module.exports = __webpack_public_path__ + "static/media/facebook.38cc0626.svg";